// libs
import styled from 'styled-components'
// themes
import colors from 'themes/colors'

const Container = styled.div`
  padding: 16px;

  .MuiFormControl-root {
    width: 100%;
  }
`

const Header = styled.div`
  display: flex;
  margin: 12px 48px 16px 0;
  color: ${colors.gray400};

  span {
    flex: 1;
  }

  > :nth-child(3) {
    flex: 0;
    min-width: 90px;
  }

  && {
    > svg {
      top: 20px;
      right: 10px;

      path {
        fill: ${colors.blue500};
      }
    }
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  margin-top: 20px;
`

export { Container, Header, ButtonsContainer }
